import { render, staticRenderFns } from "./SelecionarPersonalidade.vue?vue&type=template&id=037c9a70&scoped=true"
import script from "./SelecionarPersonalidade.vue?vue&type=script&lang=js"
export * from "./SelecionarPersonalidade.vue?vue&type=script&lang=js"
import style0 from "./SelecionarPersonalidade.vue?vue&type=style&index=0&id=037c9a70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037c9a70",
  null
  
)

export default component.exports